<template>
	<view class="box">
		<view class="search">
			<u-search placeholder="搜索会员昵称/手机号" :showAction="false" height="34" v-model="keyword"></u-search>
		</view>
		<view class="box-list">
			<view class="item">
				<view class="item-date">
					<view class="item-date-top">
						<text>2025年11月</text>
						<image src="/static/icon/ic_open@2x.png" mode="widthFix"></image>
					</view>
					<view class="item-date-bottom">
						<text>销售额：¥20000.00</text>
						<text>结算利润：¥2000.00</text>
					</view>
				</view>
				<view class="item-list">
					<view class="item-list-item">
						<view class="image">
							<image src="/static/logo.png" mode="widthFix"></image>
						</view>
						<view class="info">
							<view class="info-a">
								<view class="info-a-label">自提单</view>
								<view class="info-a-price">
									<text>4000</text>
									<text>.00</text>
								</view>
							</view>
							<view class="info-b">
								<text>李婷平-1815****5556</text>
								<text>利润¥400.00</text>
							</view>
							<view class="info-b">
								<text>订单号：713792839842</text>
								<text>11月21日 17:32:21</text>
							</view>
						</view>
					</view>
					<view class="item-list-item">
						<view class="image">
							<image src="/static/logo.png" mode="widthFix"></image>
						</view>
						<view class="info">
							<view class="info-a">
								<view class="info-a-label">配送订单</view>
								<view class="info-a-price">
									<text>4000</text>
									<text>.00</text>
								</view>
							</view>
							<view class="info-b">
								<text>李婷平-1815****5556</text>
								<text>利润¥400.00</text>
							</view>
							<view class="info-b">
								<text>订单号：713792839842</text>
								<text>11月21日 17:32:21</text>
							</view>
						</view>
					</view>
					<view class="item-list-item">
						<view class="image">
							<image src="/static/logo.png" mode="widthFix"></image>
						</view>
						<view class="info">
							<view class="info-a">
								<view class="info-a-label">配送订单</view>
								<view class="info-a-price">
									<text>4000</text>
									<text>.00</text>
								</view>
							</view>
							<view class="info-b">
								<text>李婷平-1815****5556</text>
								<text style="color: #E4001D;">已退款 -¥7800.00</text>
							</view>
							<view class="info-b">
								<text>订单号：713792839842</text>
								<text>11月21日 17:32:21</text>
							</view>
						</view>
					</view>
				</view>
			</view>
			<view class="item">
				<view class="item-date">
					<view class="item-date-top">
						<text>2025年11月</text>
						<image src="/static/icon/ic_open@2x.png" mode="widthFix"></image>
					</view>
					<view class="item-date-bottom">
						<text>销售额：¥20000.00</text>
						<text>结算利润：¥2000.00</text>
					</view>
				</view>
				<view class="item-list">
					<view class="item-list-item">
						<view class="image">
							<image src="/static/logo.png" mode="widthFix"></image>
						</view>
						<view class="info">
							<view class="info-a">
								<view class="info-a-label">自提单</view>
								<view class="info-a-price">
									<text>4000</text>
									<text>.00</text>
								</view>
							</view>
							<view class="info-b">
								<text>李婷平-1815****5556</text>
								<text>利润¥400.00</text>
							</view>
							<view class="info-b">
								<text>订单号：713792839842</text>
								<text>11月21日 17:32:21</text>
							</view>
						</view>
					</view>
					<view class="item-list-item">
						<view class="image">
							<image src="/static/logo.png" mode="widthFix"></image>
						</view>
						<view class="info">
							<view class="info-a">
								<view class="info-a-label">配送订单</view>
								<view class="info-a-price">
									<text>4000</text>
									<text>.00</text>
								</view>
							</view>
							<view class="info-b">
								<text>李婷平-1815****5556</text>
								<text>利润¥400.00</text>
							</view>
							<view class="info-b">
								<text>订单号：713792839842</text>
								<text>11月21日 17:32:21</text>
							</view>
						</view>
					</view>
					<view class="item-list-item">
						<view class="image">
							<image src="/static/logo.png" mode="widthFix"></image>
						</view>
						<view class="info">
							<view class="info-a">
								<view class="info-a-label">配送订单</view>
								<view class="info-a-price">
									<text>4000</text>
									<text>.00</text>
								</view>
							</view>
							<view class="info-b">
								<text>李婷平-1815****5556</text>
								<text style="color: #E4001D;">已退款 -¥7800.00</text>
							</view>
							<view class="info-b">
								<text>订单号：713792839842</text>
								<text>11月21日 17:32:21</text>
							</view>
						</view>
					</view>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				keyword: ''
			};
		}
	}
</script>

<style>
	page {
		background-color: #F9F9FB;
	}
</style>
<style lang="scss" scoped>
	.box {
		width: 100%;
		.search	{
			width: 100%;
			height: 110rpx;
			padding: 0 30rpx;
			box-sizing: border-box;
			background: #FFFFFF;
			position: sticky;
			top: 0;
			left: 0;
			z-index: 999;
			display: flex;
			align-items: center;
		}
		.box-list {
			width: 100%;
			display: flex;
			flex-direction: column;
			.item {
				width: 100%;
				.item-date {
					width: 100%;
					display: flex;
					flex-direction: column;
					padding: 30rpx;
					box-sizing: border-box;
					.item-date-top {
						width: 100%;
						display: flex;
						align-items: center;
						image {
							width: 26rpx;
							height: 26rpx;
							margin-left: 12rpx;
						}
						text {
							font-weight: 600;
							font-size: 32rpx;
							color: #222222;
						}
					}
					.item-date-bottom {
						width: 100%;
						display: flex;
						align-items: center;
						margin-top: 20rpx;
						text {
							font-weight: 400;
							font-size: 26rpx;
							color: #777777;
							&:nth-child(2) {
								margin-left: 62rpx;
							}
						}
					}
				}
				.item-list {
					width: 100%;
					display: flex;
					flex-direction: column;
					padding: 0 30rpx;
					box-sizing: border-box;
					background-color: #ffffff;
					.item-list-item {
						width: 100%;
						padding: 30rpx 0;
						box-sizing: border-box;
						border-bottom: 1rpx solid #E5E5E5;
						display: flex;
						align-items: flex-start;
						justify-content: center;
						.image {
							flex-shrink: 0;
							width: 72rpx;
							height: 72rpx;
							border-radius: 50%;
							overflow: hidden;
							margin-right: 20rpx;
							image {
								width: 100%;
							}
						}
						.info {
							flex: 1;
							display: flex;
							flex-direction: column;
							.info-a {
								width: 100%;
								display: flex;
								align-items: center;
								justify-content: space-between;
								.info-a-label {
									font-weight: 500;
									font-size: 30rpx;
									color: #222222;
								}
								.info-a-price {
									display: flex;
									align-items: baseline;
									text {
										&:nth-child(1) {
											font-weight: 600;
											font-size: 32rpx;
											color: #222222;
											&::before {
												content: "+";
												font-weight: 600;
												font-size: 32rpx;
												color: #222222;
											}
										}
										&:nth-child(2) {
											font-weight: 600;
											font-size: 24rpx;
											color: #222222;
										}
									}
								}
							}
							.info-b {
								width: 100%;
								display: flex;
								align-items: center;
								justify-content: space-between;
								margin-top: 12rpx;
								text {
									font-weight: 400;
									font-size: 24rpx;
									color: #999999;
								}
							}
						}
					}
				}
			}
		}
	}
</style>